import * as React from "react";
import { Button } from "@/components/ui/button";
import { AlarmReliabilityBadge, AlarmSeverityBadge } from "@/components/AlarmBadge";
import { canJustify, occurrenceTitle } from "@/features/attention/occurrence-meta";
import { OccurrenceStatusPills } from "@/features/attention/OccurrenceStatusPills";
import type { AttentionOccurrence } from "@/types/attention.types";
import { formatRelativeTime } from "@/lib/display-labels";

// Resumo limpo da ocorrência; a linha é clicável para
// abrir o modal de detalhes. O botão "Justificar" é irmão (não aninhado) do
// elemento clicável para não violar a11y (button dentro de button).
export function AttentionRow({
  occ,
  onJustify,
  onOpenDetails,
}: {
  occ: AttentionOccurrence;
  onJustify: (eventId: string) => void;
  onOpenDetails: (occurrenceId: string) => void;
}): React.ReactElement {
  const justifiable = canJustify(occ);
  return (
    <li className="bg-bg-muted-rd/40 rounded border border-border-subtle">
      <button
        type="button"
        onClick={() => onOpenDetails(occ.occurrenceId)}
        className="hover:bg-bg-muted-rd/70 block w-full space-y-1 rounded p-2 text-left focus-visible:outline-none focus-visible:[box-shadow:var(--rd-shadow-focus)]"
      >
        <div className="flex items-start justify-between gap-2">
          <span className="text-[13px] font-medium text-text-primary">{occurrenceTitle(occ)}</span>
          <span className="flex flex-wrap items-center justify-end gap-1">
            <AlarmSeverityBadge severity={occ.severity} />
            {occ.alarm ? <AlarmReliabilityBadge reliability={occ.alarm.reliability} /> : null}
            <OccurrenceStatusPills occ={occ} />
          </span>
        </div>
        <span className="block text-[11px] text-text-secondary">{occ.action}</span>
        <span className="block font-mono text-[11px] text-text-tertiary">
          {occ.machineCode ? `${occ.machineCode} · ` : ""}
          {formatRelativeTime(occ.since)}
        </span>
      </button>
      {justifiable ? (
        <div className="flex justify-end px-2 pb-2">
          <Button size="sm" variant="outline" onClick={() => onJustify(occ.justification!.refId)}>
            Justificar
          </Button>
        </div>
      ) : null}
    </li>
  );
}
